<template>
    <div class="st-summary-box rounded bg-gray-100">
        <div v-if="title" class="st-summary-box-heading">
            <div class="st-summary-box-title font-weight-bold text-dark">{{ title }}</div>
            <div v-if="subtitle" class="st-summary-box-subtitle text-dark-50">{{ subtitle }}</div>
        </div>
        <div v-for="(item, index) in items" :key="index" class="st-summary-box-row">
            <div class="st-summary-box-label text-dark-50">{{ item.label }}</div>
            <div class="st-summary-box-value text-dark-75">
                <slot name="value" :item="item">{{ item.value }}</slot>
            </div>
        </div>
    </div>
</template>

<script>
// A read-only block of label and value pairs, for a window that has to say what it acts on.
export default {
    name: 'StSummaryBox',
    props: {
        title: {
            type: String,
            default: '',
        },
        // a second, quieter line under the title
        subtitle: {
            type: String,
            default: '',
        },
        // { label, value }
        items: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.st-summary-box {
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
}

.st-summary-box-heading {
    padding-bottom: 0.75rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px solid #e4e6ef;
}

.st-summary-box-title {
    font-size: 1.1rem;
}

.st-summary-box-subtitle {
    margin-top: 0.15rem;
}

.st-summary-box-row {
    display: flex;
    gap: 1rem;
    padding: 0.2rem 0;
}

.st-summary-box-label {
    flex: 0 0 11rem;
}

.st-summary-box-value {
    flex: 1;
    min-width: 0;
    font-weight: 500;
    word-break: break-word;
}
</style>
